module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.unauthorized
  }, [(_vm.isLogingOut) ? _c('Spin', {
    attrs: {
      "size": "large",
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.$style['unauthorized-content']
  }, [_c('div', {
    class: _vm.$style['unauthorized-icon']
  }, [_c('img', {
    attrs: {
      "src": "//awp-assets.meituan.net/hfe/fep/a76da17f268c522891943db9cb3aa8e9/3funauthorized.svg"
    }
  })]), _vm._v(" "), _c('div', {
    class: _vm.$style['unauthorized-info']
  }, [_c('p', [_vm._v("\n                尊敬的商家：\n            ")]), _vm._v(" "), _c('p', {
    class: _vm.$style.content
  }, [_vm._v("\n                抱歉，您没有访问该页面的权限！\n            ")]), _vm._v(" "), _c('p', {
    class: _vm.$style.content
  }, [_vm._v("\n                如果您已是三方商家，请联系自己的业务经理咨询解决，谢谢合作！\n            ")]), _vm._v(" "), _c('button', {
    class: [_vm.$style.btn, _vm.$style['btn-warning']],
    on: {
      "click": _vm.backtoHomePage
    }
  }, [_vm._v("返回首页")]), _vm._v(" "), _c('button', {
    class: [_vm.$style.btn, _vm.$style['btn-primary']],
    attrs: {
      "disabled": _vm.isLogingOut
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("\n                退出登录\n            ")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3031b70d","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/unauthorized/Main.vue
// module id = 992
// module chunks = 0